import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=b95925ae&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b95925ae')) {
      api.createRecord('b95925ae', component.options)
    } else {
      api.reload('b95925ae', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=b95925ae&", function () {
      api.rerender('b95925ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N8JhPQrTrPNJ/JS/imageCarousel.vue"
export default component.exports